import script from "./ProfileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileMenu.vue?vue&type=style&index=0&id=5922f9c4&lang=scss"

const __exports__ = script;

export default __exports__